<template lang="pug">
v-card(max-width="600" tile).suus__mention-list
    v-list(dense)
        v-list-item-group(
            v-model="selectedIndex"
            color="primary"
            active-class="is-selected"
        )
            v-list-item(
                v-for="(item, i) in items"
                :key="i"
                color="primary"
                @click="selectItem(items[i])"
            )
                v-list-item-icon
                    v-icon(
                        color="textColor"
                        v-if="item.klass === 'member-mention'"
                        ).px-8 {{ memberIcon }}
                    v-icon(color="textColor" v-else).px-8 {{ groupIcon }}
                v-list-item-content
                    v-list-item-title(v-text="item.name")
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
import { mdiAccountCircleOutline } from "@mdi/js"
import { mdiAccountGroupOutline } from "@mdi/js"
interface Mentionable {
  id: number
  name: string
  key: string
  klass: "member-mention" | "group-mention"
}

export default Vue.extend({
  props: {
    items: {
      type: Array as PropType<Mentionable[]>,
      default: [],
    },

    command: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      selectedIndex: 0,
      memberIcon: mdiAccountCircleOutline,
      groupIcon: mdiAccountGroupOutline,
    }
  },

  watch: {
    items() {
      this.selectedIndex = 0
    },
  },

  methods: {
    onKeyDown({ event }) {
      if (event.key === "ArrowUp") {
        this.upHandler()
        return true
      }

      if (event.key === "ArrowDown") {
        this.downHandler()
        return true
      }

      if (event.key === "Enter") {
        this.enterHandler()
        return true
      }

      return false
    },

    upHandler() {
      this.selectedIndex =
        (this.selectedIndex + this.items.length - 1) % this.items.length
    },

    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length
    },

    enterHandler() {
      this.selectItem(this.items[this.selectedIndex])
    },

    selectItem(item: Mentionable) {
      //here are the mention attributes passed in
      if (item) {
        this.command({
          label: item.name,
          key: item.key,
          type: item.key.split("#")[0],
          name: item.name,
        })
      }
    },
  },
})
</script>

<style lang="sass">
$primary-color: rgba(50, 131, 247, 1)
.suus__mention-list
    .v-list-item
        .v-list-item__icon
            margin-right: 8px
    .is-selected,
    .is-selected:hover
        color: $primary-color
        background: rgba($primary-color, 0.1)
</style>
